import React, { Component } from 'react'
import { isEqual } from 'lodash'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

import { memoize } from '../../util/memoize'
import { tagWrapperItemsPropType } from './prop-types/tag-wrapper-items-prop-type'

const propTypes = {
    className: PropTypes.string,
    handleResize: PropTypes.bool,
    invisibleIndicator: PropTypes.node.isRequired,
    items: tagWrapperItemsPropType.isRequired,
    maxTooltipItems: PropTypes.number,
    maxWidth: PropTypes.number,
    renderItem: PropTypes.func,
    renderTag: PropTypes.func,
    setVisibleTagQuantity: PropTypes.func,
    tagClassName: PropTypes.string,
    tagPadding: PropTypes.number,
    tooltipPlacement: PropTypes.string
}

const defaultProps = {
    handleResize: false,
    maxTooltipItems: 10,
    renderItem: () => Function.prototype,
    setVisibleTagQuantity() {},
    tagPadding: 22,
    tooltipPlacement: 'left'
}

class TagWrapperMeasurementHelper extends Component {
    constructor(props) {
        super(props)

        this.getPortalOffset = this.getPortalOffset.bind(this)
        this.measureRenderedAndProgressNext = this.measureRenderedAndProgressNext.bind(this)

        // Create react portal
        this.portalContainer = document.createElement('div')
        Object.assign(this.portalContainer.style, { position: 'absolute', visibility: 'hidden' })
        document.body.appendChild(this.portalContainer)

        this.state = {
            isDoneCalculating: false,
            progressIndex: 0
        }

        this.renderItem = memoize(props.renderTag || props.renderItem)
    }

    componentDidMount() {
        this.measureRenderedAndProgressNext()
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const currentItems = this.props.items && this.props.items.length
        const { progressIndex } = this.state
        // if some items are hidden, only consider changes of the visible items (no need to react to changes
        // in tag 100 if only 5 are visible, as long as they dont change no new tags will be rendered)
        const relevantItemsLength =
            (nextProps.items && (currentItems !== progressIndex ? progressIndex : nextProps.items.length)) || 1
        const shouldRerenderDueToTagChanges =
            nextProps.items &&
            !isEqual(nextProps.items.slice(0, relevantItemsLength), this.props.items.slice(0, relevantItemsLength))

        if (shouldRerenderDueToTagChanges) {
            this.setState({
                isDoneCalculating: false,
                progressIndex: 0
            })
            this.renderItem.clear()
        } else if (nextProps.maxWidth !== this.props.maxWidth) {
            this.setState({
                isDoneCalculating: false,
                progressIndex: 0
            })
        }
    }

    componentDidUpdate() {
        this.measureRenderedAndProgressNext()
    }

    componentWillUnmount() {
        ReactDOM.unmountComponentAtNode(this.portalContainer)
        this.portalContainer.parentElement.removeChild(this.portalContainer)
        this.renderItem.clear()
    }

    render() {
        const { invisibleIndicator, items } = this.props
        const { isDoneCalculating, progressIndex } = this.state

        if (!items.length || isDoneCalculating) {
            return null
        }

        const measurementTags = items.slice(0, progressIndex + 1).map(this.renderItem)

        // Just check if the invisibleIndicator fits measurement if it is not the last item.
        if (measurementTags.length !== items.length) {
            measurementTags.push(invisibleIndicator)
        }

        return ReactDOM.createPortal(measurementTags, this.portalContainer)
    }

    measureRenderedAndProgressNext() {
        const { items, maxWidth, setVisibleTagQuantity } = this.props
        const { isDoneCalculating, progressIndex } = this.state
        const currentWidth = this.getPortalOffset()

        if (!isDoneCalculating && items.length) {
            if (items.length > progressIndex && currentWidth <= maxWidth) {
                this.setState({
                    progressIndex: progressIndex + 1
                })
            } else {
                setVisibleTagQuantity(progressIndex)
                this.setState({ isDoneCalculating: true })
            }
        }
    }

    getPortalOffset() {
        return this.portalContainer.offsetWidth
    }
}

TagWrapperMeasurementHelper.propTypes = propTypes
TagWrapperMeasurementHelper.defaultProps = defaultProps

export default TagWrapperMeasurementHelper
